import occamsrazor from 'occamsrazor'
const events = occamsrazor()
export default events
